export const sleep = (ms: number) =>
  new Promise((resolve: (_: void) => void) => setTimeout(resolve, ms));
